module.exports = __webpack_public_path__ + "img/banescard.772f64f0.svg";